import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import StageCandidatesPage from './pages/StageCandidatesPage';
import AddCandidatePage from './pages/AddCandidatePage';
import ViewCandidatePage from './pages/ViewCandidatePage';
import Login from './components/auth/Login';
import NotFoundPage from './pages/NotFoundPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AppLayout from './components/common/AppLayout';
import AdminPage from './pages/AdminPage';

const App: React.FC = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    {/* 404 page */}
                    <Route path="*" element={<NotFoundPage />} />
                    <Route element={<AppLayout><Outlet /></AppLayout>}>
                        {/* Protected routes */}
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <DashboardPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Candidates routes */}
                        <Route
                            path="/candidates"
                            element={
                                <ProtectedRoute>
                                    <StageCandidatesPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/candidates/recent"
                            element={
                                <ProtectedRoute>
                                    <StageCandidatesPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/candidates/stage/:stageId"
                            element={
                                <ProtectedRoute>
                                    <StageCandidatesPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* New candidate routes */}
                        <Route
                            path="/candidates/new"
                            element={
                                <ProtectedRoute>
                                    <AddCandidatePage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/candidates/:id"
                            element={
                                <ProtectedRoute>
                                    <ViewCandidatePage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Admin routes TODO add admin check */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminPage />
                                </ProtectedRoute>
                            }
                        />

                        {/* Redirect root to dashboard */}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;